import studentRecordService from './StudentRecordService';
import {getUserData} from './API';
import {uuidToHEX} from './util';
import {couldGetBenchmark, inCurrentScreeningWindow} from './screeningWindowService';
import {filterByDate} from '../components/Reports/util/validation';
import {filterActivitiesByLocale} from "Services/locale";
import {locales, SPANISHCONFIG} from "Constants/constants";

const englishStories = [
  //Kindergarten
  [
    "8d58ab80-596c-11ea-9bb9-b50636c39704",
    "4a1fd950-596d-11ea-9bb9-b50636c39704",
    "1867e1f0-596d-11ea-9bb9-b50636c39704",
    "b4d1cd90-596c-11ea-9bb9-b50636c39704",
    "f3d69d90-596c-11ea-9bb9-b50636c39704",
    "983c41c0-596b-11ea-9bb9-b50636c39704",
    "54d35ee0-596c-11ea-9bb9-b50636c39704"
  ],
  //Grade 1
  [
    //"185621c0-a328-11ec-b65b-bdd8d1052980", Deactivating as now a benchmark form
    "c7524e70-7116-11e9-84af-87f1ff3e5777",
    "ede68ec0-7116-11e9-84af-87f1ff3e5777",
    "fe3e4b00-7256-11e9-b1bd-83894e919c91",
    "03334150-7258-11e9-bbe8-11edd823450e",
    "6f5c01a0-7258-11e9-bbe8-11edd823450e",
    "003b4b40-5fc6-11e9-afeb-97aa28d47c59",
    "bc558300-7258-11e9-bbe8-11edd823450e",
    "366eac40-7117-11e9-84af-87f1ff3e5777",
    //"a5ab5090-a328-11ec-b65b-bdd8d1052980", Deactivating as now a benchmark form
    "e3b61e40-a32a-11ec-b65b-bdd8d1052980",
    "1ccc55b0-a32a-11ec-b65b-bdd8d1052980",
    "b3d5e330-a321-11ec-b65b-bdd8d1052980",
  ],
  //Grade 2
  [
    //"1161bfb0-a32c-11ec-b65b-bdd8d1052980", Deactivating as now a benchmark form
    "42758f10-5586-11e9-b3e5-f17a2d74382b",
    "b3f5fce0-7117-11e9-84af-87f1ff3e5777",
    "6c3291a0-7259-11e9-9048-67e3d3231e74",
    "b97a3300-7259-11e9-9048-67e3d3231e74",
    "3c396bd0-725a-11e9-9048-67e3d3231e74",
    "a3970ea0-5fc6-11e9-afeb-97aa28d47c59",
    "8fb5cbf0-725a-11e9-9048-67e3d3231e74",
    //"d7d55590-a326-11ec-b65b-bdd8d1052980", Deactivating as now a benchmark form
    "d2627cb0-a325-11ec-b65b-bdd8d1052980",
    "8e3f3bc0-a32c-11ec-b65b-bdd8d1052980",
    "1e7edd20-a329-11ec-b65b-bdd8d1052980",
    "9f4bf4d0-a327-11ec-b65b-bdd8d1052980",
    "8c81a2b0-a32b-11ec-b65b-bdd8d1052980",
    "4becc3c0-a3a2-11ec-84cd-cd0430810010",
    "75d3bc10-a3a3-11ec-84cd-cd0430810010",
    "2df90ab0-a3a5-11ec-84cd-cd0430810010",
    "83307660-a3a7-11ec-84cd-cd0430810010",
    "acbe7d50-aa0b-11ec-9505-5d6f0a20a971",
  ],
  //Grade 3
  [
    "4b0fea00-a32e-11ec-b65b-bdd8d1052980",
    "204c35d0-7118-11e9-84af-87f1ff3e5777",
    "003c4110-725b-11e9-9048-67e3d3231e74",
    "38bcabb0-725b-11e9-9048-67e3d3231e74",
    "75254d00-725b-11e9-9048-67e3d3231e74",
    "6be1aab0-033a-11eb-bac8-6d4b3c3de82c",
    "e5800670-7117-11e9-84af-87f1ff3e5777",
    "aafed370-94f8-11ec-b39e-131ac65cff06",
    "8c48a700-94f6-11ec-b39e-131ac65cff06",
    "f81e1730-94f6-11ec-b39e-131ac65cff06",
    //"9108c690-a32d-11ec-b65b-bdd8d1052980", Deactivating as now a benchmark form
    "34bdf7c0-a332-11ec-b65b-bdd8d1052980",
    "ba096ba0-a330-11ec-b65b-bdd8d1052980",
    "4c612320-a323-11ec-b65b-bdd8d1052980",
    "aafed370-94f8-11ec-b39e-131ac65cff06",
    "ee5c96d0-9407-11ec-b15b-1d8e35bb4883",
    //"3eda3e10-9646-11ec-b4e3-9fd7b0b2c65c",
  ],
  //Grade 4
  [
    "b5ceeef0-0d82-11ec-91e3-71363817c29b",
    "285b6b00-79a4-11ec-b8ae-bb8d44e3c3d5",
    //"43a55970-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    "f66115b0-0d82-11ec-91e3-71363817c29b",
    "8302cd20-94f5-11ec-b39e-131ac65cff06",
    "ee5c96d0-9407-11ec-b15b-1d8e35bb4883",
    "798421b0-a326-11ec-b65b-bdd8d1052980",
    "84f86c80-a3a4-11ec-84cd-cd0430810010",
    "1dcff7b0-a3a6-11ec-84cd-cd0430810010",
    "d6223f30-a3a6-11ec-84cd-cd0430810010",
    "06788060-aa0d-11ec-9505-5d6f0a20a971",
    "f2b29130-aa05-11ec-9505-5d6f0a20a971",
    "20d4c560-aa0b-11ec-9505-5d6f0a20a971",
    "8c286600-abb9-11ec-a607-970272a99d4d",
    "8302cd20-94f5-11ec-b39e-131ac65cff06",
    "f81e1730-94f6-11ec-b39e-131ac65cff06",
    "1f97a3e0-94f6-11ec-b39e-131ac65cff06",
  ],
  //Grade 5
  [
    //"6ab4e440-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    //"885ebbb0-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    //"a3a63920-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    "ee44c4c0-1431-11ec-a8ee-679889a2bda0",
    "348e8b00-1432-11ec-a8ee-679889a2bda0",
    "1f97a3e0-94f6-11ec-b39e-131ac65cff06",
    "96d83010-aa0d-11ec-9505-5d6f0a20a971",
    "a87ddfb0-aa06-11ec-9505-5d6f0a20a971",
    "94f04f80-aa08-11ec-9505-5d6f0a20a971",
    "3c39ad70-aadd-11ec-9c29-fb763abd79e3",
    "a40388f0-abb8-11ec-a607-970272a99d4d",
    "0ab762a0-abba-11ec-a607-970272a99d4d",
    "8c48a700-94f6-11ec-b39e-131ac65cff06",
  ],
  //Grade 6 (Copy of Grade 5)
  [
    //"6ab4e440-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    //"885ebbb0-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    //"a3a63920-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    "ee44c4c0-1431-11ec-a8ee-679889a2bda0",
    "348e8b00-1432-11ec-a8ee-679889a2bda0",
    "1f97a3e0-94f6-11ec-b39e-131ac65cff06",
    "96d83010-aa0d-11ec-9505-5d6f0a20a971",
    "a87ddfb0-aa06-11ec-9505-5d6f0a20a971",
    "94f04f80-aa08-11ec-9505-5d6f0a20a971",
    "3c39ad70-aadd-11ec-9c29-fb763abd79e3",
    "a40388f0-abb8-11ec-a607-970272a99d4d",
    "0ab762a0-abba-11ec-a607-970272a99d4d",
    "8c48a700-94f6-11ec-b39e-131ac65cff06",
  ],
  //Grade 7 (Copy of Grade 5)
  [
    //"6ab4e440-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    //"885ebbb0-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    //"a3a63920-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    "ee44c4c0-1431-11ec-a8ee-679889a2bda0",
    "348e8b00-1432-11ec-a8ee-679889a2bda0",
    "1f97a3e0-94f6-11ec-b39e-131ac65cff06",
    "96d83010-aa0d-11ec-9505-5d6f0a20a971",
    "a87ddfb0-aa06-11ec-9505-5d6f0a20a971",
    "94f04f80-aa08-11ec-9505-5d6f0a20a971",
    "3c39ad70-aadd-11ec-9c29-fb763abd79e3",
    "a40388f0-abb8-11ec-a607-970272a99d4d",
    "0ab762a0-abba-11ec-a607-970272a99d4d",
    "8c48a700-94f6-11ec-b39e-131ac65cff06",
  ],
  //Grade 8 (Copy of Grade 5)
  [
    //"6ab4e440-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    //"885ebbb0-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    //"a3a63920-79a4-11ec-b8ae-bb8d44e3c3d5", Deactivating because of bad language model
    "ee44c4c0-1431-11ec-a8ee-679889a2bda0",
    "348e8b00-1432-11ec-a8ee-679889a2bda0",
    "1f97a3e0-94f6-11ec-b39e-131ac65cff06",
    "96d83010-aa0d-11ec-9505-5d6f0a20a971",
    "a87ddfb0-aa06-11ec-9505-5d6f0a20a971",
    "94f04f80-aa08-11ec-9505-5d6f0a20a971",
    "3c39ad70-aadd-11ec-9c29-fb763abd79e3",
    "a40388f0-abb8-11ec-a607-970272a99d4d",
    "0ab762a0-abba-11ec-a607-970272a99d4d",
    "8c48a700-94f6-11ec-b39e-131ac65cff06",
  ],
  // Pre-Kindergarten, copy of Kindergarten
  [
    "8d58ab80-596c-11ea-9bb9-b50636c39704",
    "4a1fd950-596d-11ea-9bb9-b50636c39704",
    "1867e1f0-596d-11ea-9bb9-b50636c39704",
    "b4d1cd90-596c-11ea-9bb9-b50636c39704",
    "f3d69d90-596c-11ea-9bb9-b50636c39704",
    "983c41c0-596b-11ea-9bb9-b50636c39704",
    "54d35ee0-596c-11ea-9bb9-b50636c39704"
  ],
];

const spanishStories = [
  //Kindergarten
  [
    "8b60f620-4c68-11ec-a716-a39fe8d96d11",
    "4f7a40f0-4c66-11ec-a716-a39fe8d96d11",
    "f5661db0-4c69-11ec-a716-a39fe8d96d11",
    "4e4f4d20-4c74-11ec-a716-a39fe8d96d11",
    "cd5a3080-4c74-11ec-a716-a39fe8d96d11",
  ],
  //Grade 1
  [
    "17d74130-4c6a-11ec-a716-a39fe8d96d11",
    "34710730-4c75-11ec-a716-a39fe8d96d11",
    "1aa678b0-4c68-11ec-a716-a39fe8d96d11",
    //"ab9bffc0-4c68-11ec-a716-a39fe8d96d11", Deactivating as this is also a benchmark form
    "f9439a70-4c73-11ec-a716-a39fe8d96d11",
  ],
  //Grade 2
  [
    "8cb35c30-4c67-11ec-a716-a39fe8d96d11",
    "d7111220-4c69-11ec-a716-a39fe8d96d11",
    "f247d8a0-4c67-11ec-a716-a39fe8d96d11",
    "94036ea0-4c6a-11ec-a716-a39fe8d96d11",
    "3ec544d0-4c6b-11ec-a716-a39fe8d96d11",
  ],
  //Grade 3
  [
    "4c8fb940-4c68-11ec-a716-a39fe8d96d11",
    "c8e24780-4c75-11ec-a716-a39fe8d96d11",
    "b1b76920-4c73-11ec-a716-a39fe8d96d11",
    "b7c890c0-4c67-11ec-a716-a39fe8d96d11",
    "c2d50ef0-4c6a-11ec-a716-a39fe8d96d11",
  ],
  //Grade 4
  [
    "d28a1fe0-4c68-11ec-a716-a39fe8d96d11",
    "fc856280-4c74-11ec-a716-a39fe8d96d11",
    "3bd69b40-4c69-11ec-a716-a39fe8d96d11",
    "a7344360-4c69-11ec-a716-a39fe8d96d11",
    "df0af4f0-4c73-11ec-a716-a39fe8d96d11",
  ],
  //Grade 5
  [
    "97f456e0-4c75-11ec-a716-a39fe8d96d11",
    "dbe3d740-4c66-11ec-a716-a39fe8d96d11",
    "83821360-4c74-11ec-a716-a39fe8d96d11",
    "1553abf0-4c5c-11ec-a716-a39fe8d96d11",
    "0b52cc30-4c6b-11ec-a716-a39fe8d96d11",
  ],
  //Grade 6 (Copy of Grade 5)
  [
    "97f456e0-4c75-11ec-a716-a39fe8d96d11",
    "dbe3d740-4c66-11ec-a716-a39fe8d96d11",
    "83821360-4c74-11ec-a716-a39fe8d96d11",
    "1553abf0-4c5c-11ec-a716-a39fe8d96d11",
    "0b52cc30-4c6b-11ec-a716-a39fe8d96d11",
  ],
  //Grade 7 (Copy of Grade 5)
  [
    "97f456e0-4c75-11ec-a716-a39fe8d96d11",
    "dbe3d740-4c66-11ec-a716-a39fe8d96d11",
    "83821360-4c74-11ec-a716-a39fe8d96d11",
    "1553abf0-4c5c-11ec-a716-a39fe8d96d11",
    "0b52cc30-4c6b-11ec-a716-a39fe8d96d11",
  ],
  //Grade 8 (Copy of Grade 5)
  [
    "97f456e0-4c75-11ec-a716-a39fe8d96d11",
    "dbe3d740-4c66-11ec-a716-a39fe8d96d11",
    "83821360-4c74-11ec-a716-a39fe8d96d11",
    "1553abf0-4c5c-11ec-a716-a39fe8d96d11",
    "0b52cc30-4c6b-11ec-a716-a39fe8d96d11",
  ],
  // Pre-Kindergarten, copy of Kindergarten
  [
    "8b60f620-4c68-11ec-a716-a39fe8d96d11",
    "4f7a40f0-4c66-11ec-a716-a39fe8d96d11",
    "f5661db0-4c69-11ec-a716-a39fe8d96d11",
    "4e4f4d20-4c74-11ec-a716-a39fe8d96d11",
    "cd5a3080-4c74-11ec-a716-a39fe8d96d11",
  ],
];

const pmStories = {
  "en-us": englishStories,
  "es-mx": spanishStories,
}

export async function getProgressMonitoringStory(grade,studentId){
    return studentRecordService.getTestMetadata([uuidToHEX(studentId)], 60, ["assessment"], ["scored","rescored"])
    .then((assessments)=>{
      assessments = filterByDate(assessments);
      let pmAssessments = assessments.map((act)=>{
        return act.storyId;
      });

      const locale = getUserData().locale || 'en-us';
      const pmStoriesForLocale = pmStories[locale];

      let possibleStories = pmStoriesForLocale[grade === -1 ? pmStoriesForLocale.length - 1 : grade].filter((story)=>{
        return !pmAssessments.includes(uuidToHEX(story));
      });

      if(possibleStories[0]){
        return studentRecordService.getRecommendedStories(null,grade,["assessment"],1,possibleStories[0])
        .then((stories)=>{
          return Promise.resolve(stories);
        })
      }else{
        return Promise.resolve([]);
      }
    });
}
